module.exports = __webpack_public_path__ + "static/review_image-02734fd6cf34198d820b80c9f5e271b6.svg";